import { makeStyles } from '@material-ui/core'
import React from 'react'
import packageJson from '../../package.json'

const useStyles = makeStyles(theme => ({
    root: {
        height: 50,
        padding: '12px 24px',
        flexShrink: 0,
        display: 'flex',
        justifyContent: 'space-between'
    },
    link: {
        textDecoration: 'none',
        alignSelf: 'center',
        color: '#03989E',
        paddingRight: 10,
        fontSize:18,
        fontWeight:600,
        '&:hover': {
            textDecoration: 'underline'
        }
    },
    right: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        justifyContent: 'center',
    },
    copyright: {
        color:'#8A8A8A',
        fontSize:18,
        fontWeight:600,
        fontStyle: 'normal',
        margin: 0,
    },
    version: {
        color: '#B0B0B0',
        fontSize: 11,
        margin: 0,
    }
}))

export default function Footer() {
    const classes = useStyles()
    const version = process.env.REACT_APP_VERSION || packageJson.version

    return (
        <div className={classes.root}>
            <div>
                <a
                    href="https://www.safeportersecure.com/privacy-and-security"
                    target="_blank"
                    rel="noreferrer"
                    className={classes.link}
                >
                    Privacy
                </a>
                <a
                    href="https://www.safeportersecure.com/cookie-policy"
                    target="_blank"
                    rel="noreferrer"
                    className={classes.link}
                >
                    Cookie Policy
                </a>
            </div>
            <div className={classes.right}>
                <p className={classes.copyright}>&copy; 2025 - SafePorter</p>
                <p className={classes.version}>v{version}</p>
            </div>
        </div>
    )
}
